module.exports = __webpack_public_path__ + "img/网络文化经营许可证.f557b110.png";